import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../../utils/cn';

// Icons
import { ReactComponent as AlertIcon } from '../../../assets/icons/alert.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info.svg';
import { ReactComponent as SuccessIcon } from '../../../assets/icons/success.svg';

import styles from './FlashMessage.module.scss';

function FlashMessage({
  message, color, className, isPopNotif,
}) {
  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return <SuccessIcon className={styles.icon} width={20} height={20} />;
      case 'error':
        return <AlertIcon className={styles.icon} />;
      default:
        return <InfoIcon className={styles.icon} />;
    }
  };

  return (
    <div
      className={cn([
        'd-flex a-center',
        styles.flash,
        color ? styles[color] : '',
        className || '',
        isPopNotif ? styles.pop : '',
      ])}
    >
      {getIcon(color)}
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
}

FlashMessage.propTypes = {
  message: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'warning', 'error', 'success']),
  className: PropTypes.string,
  isPopNotif: PropTypes.bool,
};

FlashMessage.defaultProps = {
  message: '',
  color: 'primary',
  className: '',
  isPopNotif: false,
};

export default FlashMessage;
